import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { BasicItemMenuButton } from '../common';
import type { GroupMember } from '@group/hooks/useGroupMembers';

type Props = {
  memberData: GroupMember;
  setRemovableMemberData: (memberData: GroupMember) => void;
  disabled: boolean;
};

export const ItemMenuButton: React.FC<Props> = ({ memberData, setRemovableMemberData, disabled }: Props) => {
  const { t } = useTranslation();
  const handleRemoveMember = useCallback(() => {
    setRemovableMemberData(memberData);
  }, [memberData, setRemovableMemberData]);

  return (
    <BasicItemMenuButton
      menuTitle={t('group.members.itemMenu.remove')}
      onClickMenu={handleRemoveMember}
      disabled={disabled}
    />
  );
};
